import { Colors } from '@digilize/shared/definitions/src';

import { hexToRgba } from './hexToRgba';

export const setPaulyCustomTheme = (colors: Colors) => {
  if (colors.background_primary != null && colors.background_primary !== '') {
    document.documentElement.style.setProperty('--pauly-shop-color-bg-primary', colors.background_primary);
    document.documentElement.style.setProperty(
      '--pauly-shop-color-bg-primary-03',
      hexToRgba(colors.background_primary, 0.3)
    );
    document.documentElement.style.setProperty(
      '--pauly-shop-color-bg-primary-05',
      hexToRgba(colors.background_primary, 0.5)
    );
  }
  if (colors.background_primary_text != null && colors.background_primary_text !== '') {
    document.documentElement.style.setProperty('--pauly-shop-color-font-primary', colors.background_primary_text);
  }
  if (colors.background_secondary != null && colors.background_secondary !== '') {
    document.documentElement.style.setProperty('--pauly-shop-color-bg-secondary', colors.background_secondary);
  }
  if (colors.background_secondary_text != null && colors.background_secondary_text !== '') {
    document.documentElement.style.setProperty('--pauly-shop-color-font-secondary', colors.background_secondary_text);
    document.documentElement.style.setProperty(
      '--pauly-shop-color-font-secondary-08',
      hexToRgba(colors.background_secondary_text, 0.8)
    );
  }
  if (colors.primary != null && colors.primary !== '') {
    document.documentElement.style.setProperty('--pauly-shop-color-primary', colors.primary);
  }
  if (colors.primary_text != null && colors.primary_text !== '') {
    document.documentElement.style.setProperty('--pauly-shop-color-primary-text', colors.primary_text);
  }
  if (colors.background_input != null && colors.background_input !== '') {
    document.documentElement.style.setProperty('--pauly-shop-color-input-fill', colors.background_input);
    document.documentElement.style.setProperty(
      '--pauly-shop-color-input-border',
      hexToRgba(colors.background_input, 0.8)
    );
  }
  if (colors.background_input_text != null && colors.background_input_text !== '') {
    document.documentElement.style.setProperty('--pauly-shop-color-input-text', colors.background_input_text);
  }
};
